module.exports = __webpack_public_path__ + "img/icon_pin.03282475.png";